const CHAVE = 'dadosMotorista'

export const gravarDados = (dados) => {
  sessionStorage.setItem(CHAVE,JSON.stringify(dados));
}

export const obterDados = () =>  JSON.parse(sessionStorage.getItem(CHAVE));